// extracted by mini-css-extract-plugin
export default {"curved_white_top_border":"fancy_curved_white_top_border__0mwhG"};